// @flow
import React, { useCallback } from 'react';
import classNames from 'classnames/bind';

import styles from './ProductGalleryThumb.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  imgSrc: string,
  title?: string,
  onClick?: (link: number | string) => void,
  active?: boolean,
  id?: number | string,
}

const ProductGalleryThumb = ({ imgSrc, title, onClick, active, id }: Props) => {
  const handleClick = useCallback((e) => {
    e.preventDefault();
    if (id && typeof onClick === 'function') {
      onClick(id);
    }
  }, [onClick, id]);

  return (
    <a href="view" className={cx(styles.root, { active })} onClick={handleClick}>
      <img src={imgSrc} alt={title} className={styles.image} />
    </a>
  );
};

export default ProductGalleryThumb;
